import { SET_NOTIFICATION_COUNT } from "../actions/notification";

const initialState = {
  count: 0,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_NOTIFICATION_COUNT:
      return { ...state, count: action.payload.count };
    default:
      return state;
  }
};

export const selectNotificationCount = (state) => state.notification.count;